module.exports = __webpack_public_path__ + "static/media/NJTVNews_landing_ongradient.5130d5c9.svg";